/**
 * Main map page
 */

angular
  .module("routes")
  .controller(
    "map",
    function (
      $rootScope,
      $scope,
      $geolocation,
      GoogleGeocoder,
      $state,
      workspaces,
      workspace,
      Collection,
      $window,
      $q,
      $timeout,
      Map,
      Workspace,
      Session,
      entity,
      Storage,
      $location,
      INSTANCE_ID,
      MappingModals,
      hasMapAccess,
      $controller
    ) {
      $scope.isPublicPage = true;

      // Inherit from the original TruTerritory controller
      $controller("truterritory", {
        $rootScope,
        $scope,
        $geolocation,
        GoogleGeocoder,
        $state,
        workspaces,
        workspace,
        Collection,
        $window,
        $q,
        $timeout,
        Map,
        Workspace,
        Session,
        entity,
        Storage,
        $location,
        INSTANCE_ID,
        MappingModals,
        hasMapAccess,
      });

      $scope.zoom = $state.params.zoom;
      $scope.center = [$state.params.lat || null, $state.params.lng || null];
      $scope.map = Map.getEmptyMap();

      let mapOptions = {};
      if ($state.params.o) {
        let o = $state.params.o;
        mapOptions.o = o instanceof Array ? o : [o];
      }

      $scope.hasAccess = function () {
        return false;
      };

      $scope.setupMap = function(truMap) {
        $scope.truMap = truMap;

        Map.getByUUID($state.params.UUID, mapOptions)
          .then(function (map) {
            // Get a password from the user if required
            if (map.passwordRequired) {
              requirePassword(map);
            } else {
              load(map);
            }
          })
          .catch(function (response) {
            console.log('Error loading map', response);
            $state.go("not-found");
          });
      }

      function load(map) {
        $scope.setOriginalMap(map);
        map.isPublic = true;
        $scope.workspace = { collections: map.collections };

        return $scope.addMap(map, false).then(function () {
          if (map.annotations && map.annotations.features) $scope.truMap.setDrawnItems(map.annotations.features);
        });
      }

      function requirePassword(map, first = true) {
        MappingModals.openPassword(first).then(function (password) {
          map.password = password;
          load(map).catch(function (response) {
            if (response.status == 403) requirePassword(map, false);
          });
        });
      }
    }
  );
